<template>
  <div>
    <q-dialog v-model="valor">
      <q-card
        class="text-brand-5 text-weight-bold"
        style="height: 500px; max-width: 900px; width: 900px"
      >
        <q-card-section>
          <div class="text-h6">{{ titulo }}</div>
        </q-card-section>
        <q-separator />

        <q-card-section class="row">
          <!-- loading inicial enquanto carrega healthcheck e fingers -->
          <div v-if="loadingInicial" class="row col-12" style="height: 300px">
            <div class="row col-12">
              <div class="row col-12 justify-center">
                <p class="text-h6 q-mt-md" style="text-align: center">
                  Carregando informações dos dedos cadastrados, aguarde.
                </p>
              </div>
              <div class="row col-12 q-mt-lg justify-center">
                <q-circular-progress
                  indeterminate
                  rounded
                  size="70px"
                  color="primary"
                  class="q-mt-xl"
                />
              </div>
            </div>
          </div>

          <div class="row" v-else-if="aplicacaoExecutando">
            <!-- loading durante o cadastro da biometria (enroll) -->
            <div
              v-if="loadingCadastro"
              style="
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(255, 255, 255, 0.95);
                z-index: 9999;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <div style="text-align: center">
                <p class="text-h6 q-mb-md">Cadastrando biometria, aguarde...</p>
                <q-circular-progress
                  indeterminate
                  rounded
                  size="70px"
                  color="primary"
                />
              </div>
            </div>

            <SelecaoDeDedo
              draggable
              @dedo="receberDedo"
              :limparDados="removerDedo"
              :dedosSelecionados="dedosSelecionados"
              :tipoBiometria="'cadastro'"
              v-if="!biometria && tipoBiometria == 'cadastro'"
            />
            <img v-show="biometria" src="" id="image" alt="" />
            <div class="col q-ml-lg" style="height: 300px">
              <!-- mensagem apos coleta da imagem -->
              <div
                v-if="biometria && tipoBiometria == 'cadastro'"
                class="row col-12"
              >
                <div class="row col-12 justify-center">
                  <p
                    class="text-h6 q-mt-md"
                    style="text-align: center; font-weight: 500"
                  >
                    Se estiver satisfeito com a imagem coletada, clique em
                    <strong style="color: #4caf50">Salvar Biometria</strong>, do
                    contrário, refaça o processo clicando em
                    <strong style="color: #1976d2">Refazer</strong>.
                  </p>
                </div>
              </div>

              <div class="row col-12" v-if="!biometria">
                <div class="row col-12 justify-center">
                  <p
                    class="text-h6"
                    v-if="
                      tipoBiometria == 'verificacao' ||
                      tipoBiometria == 'verificacaoUsuario'
                    "
                  >
                    {{ mensagem }}
                  </p>
                  <p v-else>{{ mensagem }}</p>
                </div>
                <div class="row col-12 q-mt-lg justify-center">
                  <q-circular-progress
                    v-if="loading"
                    indeterminate
                    rounded
                    size="70px"
                    color="primary"
                    class="q-mt-xl"
                  />
                </div>
              </div>
              <SelecaoDeDedo
                draggable
                @dedo="receberDedo"
                :limparDados="removerDedo"
                :dedosSelecionados="dedosSelecionados"
                :tipoBiometria="'verificacao'"
                v-if="!biometria && tipoBiometria == 'verificacao' && !loading"
              />
              <SelecaoDeDedo
                draggable
                @dedo="receberDedo"
                :limparDados="removerDedo"
                :dedosSelecionados="dedosSelecionados"
                :tipoBiometria="'verificacao'"
                v-if="
                  !biometria &&
                  tipoBiometria == 'verificacaoUsuario' &&
                  !loading
                "
              />
            </div>
          </div>
          <div v-else class="row col-12" style="height: 300px">
            <div class="row col-12">
              <q-icon
                class="row justify-center col-12"
                size="70px"
                name="error_outline"
              />
              <div class="row col-12 justify-center">
                <span
                  style="text-align: center"
                  class="text-h6 q-mt-sm"
                  v-html="mensagemErro"
                ></span>
                <a
                  target="blank"
                  style="cursor: pointer"
                  href="https://sites.google.com/multpex.com.br/basedeconhecimento/d%C3%BAvidas-administrativas/download-e-instala%C3%A7%C3%A3o-leitor-biom%C3%A9trico-web"
                  ><q-icon size="50px" name="book" color="brand-1"
                /></a>
              </div>
            </div>
          </div>
        </q-card-section>

        <q-separator />
        <q-card-actions align="right" class="q-mt-lg">
          <div v-if="aplicacaoExecutando" class="row col justify-start q-ml-md">
            <div>
              <div class="row items-center">
                <div
                  style="
                    background-color: green;
                    width: 12px;
                    height: 12px;
                    border-radius: 3px;
                  "
                ></div>
                <span class="q-ml-xs">Dedos Cadastrados</span>
              </div>
              <div v-if="tipoBiometria == 'cadastro'" class="row items-center">
                <div
                  style="
                    background-color: yellow;
                    width: 13px;
                    height: 13px;
                    border-radius: 3px;
                  "
                ></div>
                <span class="q-ml-xs">Dedo Selecionado</span>
              </div>
            </div>
          </div>
          <q-btn
            icon="close"
            label="Fechar"
            color="negative"
            no-caps
            v-close-popup
          />
          <div
            class="q-gutter-x-sm q-ml-xs"
            v-if="
              tipoBiometria == 'verificacao' ||
              tipoBiometria == 'verificacaoUsuario'
            "
          >
            <q-btn
              v-if="base64Images.length > 0"
              icon="refresh"
              label="Refazer"
              color="primary"
              no-caps
              @click="refazer()"
            />
            <q-btn
              v-if="base64Images.length == 0 && aplicacaoExecutando"
              :disable="biometria"
              icon="fingerprint"
              label="Coletar Biometria"
              color="positive"
              no-caps
              @click="coletarBiometria()"
            />
          </div>
          <div class="q-gutter-x-sm q-ml-xs" v-if="tipoBiometria == 'cadastro'">
            <q-btn
              v-if="base64Images.length > 0"
              icon="refresh"
              label="Refazer"
              color="primary"
              no-caps
              :disable="disable"
              @click="refazer()"
            />
            <q-btn
              v-if="base64Images.length > 0"
              icon="fingerprint"
              label="Salvar Biometria"
              color="positive"
              no-caps
              @click="cadastrarBiometria()"
            />
          </div>
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { ref, watch } from "vue";
import { useQuasar } from "quasar";
import SelecaoDeDedo from "../components/SelecaoDeDedo.vue";
import { useStore } from "vuex";
export default {
  props: ["modal", "userId", "titulo", "tipoBiometria"],
  emits: ["atualizarBiometrias", "negativePrint", "resultadoVerificacao"],
  components: { SelecaoDeDedo },
  setup(props, { emit }) {
    const quasar = useQuasar();
    const store = useStore();
    let valor = ref(false);

    let dedoSelecionado = ref(null);
    let mensagem = ref("Selecione um dedo para começar o processo");
    let biometria = ref(false);
    let removerDedo = ref(0);
    const base64Images = ref([]);
    let loading = ref(false);
    let disable = ref(false);
    const negativePrint = ref("");
    const mensagemErro = ref("");
    const aplicacaoExecutando = ref(false);
    const dedosSelecionados = ref("");
    const versaoRegex = /^1\.(\d+)\.(\d+)$/;
    const tenentsNovaBiometria = [];
    const loadingInicial = ref(false);
    const loadingCadastro = ref(false);
    const validarBase64 = (str) => {
      if (!str || typeof str !== "string") {
        return false;
      }

      // verifica se tem tamanho minimo razoavel
      if (str.length < 10000) {
        return false;
      }

      // verifica se contem apenas caracteres validos de base64
      const base64Regex = /^[A-Za-z0-9+/=]+$/;
      if (!base64Regex.test(str)) {
        return false;
      }

      // verifica se o tamanho é multiplo de 4 (caracteristica de base64)
      if (str.length % 4 !== 0) {
        return false;
      }

      return true;
    };

    const coletarBiometria = async () => {
      loading.value = true;
      disable.value = true;

      // cria um timeout para detectar resposta muito lenta
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
          reject(new Error("TIMEOUT"));
        }, 30000); // 30 segundos
      });

      try {
        // race entre a chamada e o timeout
        let response = await Promise.race([
          store.dispatch("biometria/getIdentification"),
          timeoutPromise,
        ]);

        // verifica se a resposta está completa e valida
        if (!response || !response.data) {
          quasar.notify({
            message:
              "Falha ao coletar biometria, refaça o processo clicando no botão de Refazer.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          loading.value = false;
          disable.value = false;
          refazer();
          return;
        }

        // verifica se a resposta tem as propriedades esperadas
        if (
          !Object.prototype.hasOwnProperty.call(response.data, "sucesso") ||
          !Object.prototype.hasOwnProperty.call(
            response.data,
            "imagemDigital"
          ) ||
          !Object.prototype.hasOwnProperty.call(
            response.data,
            "imagemDigitalNegativa"
          )
        ) {
          quasar.notify({
            message:
              "Falha ao coletar biometria, refaça o processo clicando no botão de Refazer.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          loading.value = false;
          disable.value = false;
          refazer();
          return;
        }

        if (!response.data.sucesso) {
          quasar.notify({
            message: response.data.mensagemErro || "Erro ao coletar biometria",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          loading.value = false;
          disable.value = false;
          refazer();
          return;
        }

        let fingerPrint = response.data.imagemDigital;
        negativePrint.value = response.data.imagemDigitalNegativa;

        // valida se as imagens base64 sao validas
        const fingerPrintValido = validarBase64(fingerPrint);
        const negativePrintValido = validarBase64(negativePrint.value);

        if (!fingerPrintValido || !negativePrintValido) {
          quasar.notify({
            message:
              "Falha ao coletar biometria, refaça o processo clicando no botão de Refazer.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          loading.value = false;
          disable.value = false;
          refazer();
          return;
        }

        // se tudo validado, tenta carregar a imagem
        let image = document.getElementById("image");

        // cria um Image temporário para testar se o base64 pode ser carregado
        const testImage = new Image();
        const imageDataUrl = "data:image/png;base64," + negativePrint.value;

        testImage.onload = () => {
          // verificar se a imagem tem dimensoes validas
          // imagem corrompida geralmente tem dimensoes muito pequenas ou invalidas
          if (testImage.width < 50 || testImage.height < 50) {
            quasar.notify({
              message:
                "Falha ao coletar biometria, refaça o processo clicando no botão de Refazer.",
              color: "negative",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
            loading.value = false;
            disable.value = false;
            refazer();
            return;
          }

          // imagem válida, pode prosseguir
          biometria.value = true;
          image.src = imageDataUrl;
          base64Images.value.push(fingerPrint);

          loading.value = false;
          disable.value = false;

          if (props.tipoBiometria == "verificacao") {
            verificarBiometria();
            return;
          }
          if (props.tipoBiometria == "verificacaoUsuario") {
            encontrarUsuarioBiometria();
          }
          mensagem.value =
            "Clique em Salvar Biometria para completar o cadastro";
        };

        testImage.onerror = () => {
          quasar.notify({
            message:
              "Falha ao coletar biometria, refaça o processo clicando no botão de Refazer.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          loading.value = false;
          disable.value = false;
          refazer();
        };

        // tenta carregar a imagem
        testImage.src = imageDataUrl;
      } catch (error) {
        let mensagemErro =
          "Falha ao coletar biometria, refaça o processo clicando no botão de Refazer.";

        // se for erro de timeout
        if (error.message === "TIMEOUT") {
          mensagemErro =
            "A conexão está muito lenta. Falha ao coletar biometria, refaça o processo.";
        } else if (
          error.response &&
          error.response.data &&
          error.response.data.mensagemErro
        ) {
          mensagemErro = error.response.data.mensagemErro;
        }

        quasar.notify({
          message: mensagemErro,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        loading.value = false;
        disable.value = false;
        refazer();
      }
    };

    const getVersion = async () => {
      let response = undefined;
      loadingInicial.value = true;

      try {
        //if (
        //  tenentsNovaBiometria.includes(store.state.autenticacao.cliente[0])
        //) {
        //  const isLive = await store.dispatch("biometria/getVersionNew");
        //  if (isLive.status != 200) {
        //    mensagemErro.value =
        //      "Biometria não está funcionando, favor contatar o suporte.";
        //    return;
        //  }
        //  response = await store.dispatch("biometria/getVersion");
        //} else {
        response = await store.dispatch("biometria/getVersion");
        //}

        if (validarVersao(response.data.versao)) {
          aplicacaoExecutando.value = true;
          await receberDedosCadastrados();
          loadingInicial.value = false;
          return;
        }
        mensagemErro.value =
          "Versão desatualizada, por favor faça o download da nova versão.";
        loadingInicial.value = false;
      } catch (error) {
        mensagemErro.value =
          "Aplicação desktop parada, favor iniciar antes de começar as rotinas de cadastro/verificação. Se não tiver a aplicação instalada, favor consultar procedimento para dowload";
        loadingInicial.value = false;
      }
    };

    const coletarNovamente = () => {
      base64Images.value = [];
      biometria.value = false;
      removerDedo.value++;
      mensagem.value = "Selecione um dedo para começar o processo";
    };

    const cadastrarBiometria = async () => {
      loading.value = true;
      loadingCadastro.value = true;

      try {
        if (
          !tenentsNovaBiometria.includes(store.state.autenticacao.cliente[0])
        ) {
          await store.dispatch("biometria/cadastrarBiometriaNew", {
            employeeId: props.userId,
            base64Image: base64Images.value,
            fingerPosition: dedoSelecionado.value.value,
            imageWidth: 320,
            imageHeight: 480,
            imageResolution: 500,
          });
        } else {
          await store.dispatch("biometria/cadastrarBiometria", {
            employeeId: props.userId,
            base64Images: base64Images.value,
            fingerPosition: dedoSelecionado.value.value,
            imageWidth: 320,
            imageHeight: 480,
            imageResolution: 500,
          });
        }
        loading.value = false;
        loadingCadastro.value = false;
        quasar.notify({
          message: "Biometria cadastrada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        emit("atualizarBiometrias");
        refazer();
        receberDedosCadastrados();
      } catch (error) {
        console.log(error);
        loading.value = false;
        loadingCadastro.value = false;
        quasar.notify({
          message: "Erro ao cadastrar biometria",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const verificarBiometria = async () => {
      let response = undefined;
      try {
        if (
          !tenentsNovaBiometria.includes(store.state.autenticacao.cliente[0])
        ) {
          response = await store.dispatch("biometria/verificarBiometriaNew", {
            userId: props.userId,
            base64Image: base64Images.value[0],
            imageWidth: 320,
            imageHeight: 480,
            imageResolution: 500,
          });
        } else {
          response = await store.dispatch("biometria/verificarBiometria", {
            userId: props.userId,
            base64Image: base64Images.value[0],
            imageWidth: 320,
            imageHeight: 480,
            imageResolution: 500,
          });
        }

        emit("negativePrint", negativePrint.value);
        if (response.data == props.userId) {
          quasar.notify({
            message: "Biometria verificada com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          emit("resultadoVerificacao", true);
          valor.value = false;
          return;
        }
        quasar.notify({
          message:
            "A biometria verificada não coincide com a do solicitante, faça novamente o processo de verificação.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        emit("resultadoVerificacao", false);
        refazer();
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao verificar biometria",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const encontrarUsuarioBiometria = async () => {
      let response = undefined;
      try {
        if (
          !tenentsNovaBiometria.includes(store.state.autenticacao.cliente[0])
        ) {
          response = await store.dispatch("biometria/verificarBiometriaNew", {
            userId: props.userId,
            base64Image: base64Images.value[0],
            imageWidth: 320,
            imageHeight: 480,
            imageResolution: 500,
          });
        } else {
          response = await store.dispatch("biometria/verificarBiometria", {
            userId: props.userId,
            base64Image: base64Images.value[0],
            imageWidth: 320,
            imageHeight: 480,
            imageResolution: 500,
          });
        }
        emit("negativePrint", negativePrint.value);
        if (response.data == props.userId) {
          quasar.notify({
            message: "Biometria verificada com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          emit("resultadoVerificacao", true);
          valor.value = false;
          return;
        }
        quasar.notify({
          message:
            "A biometria verificada não coincide com a do solicitante, faça novamente o processo de verificação.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        emit("resultadoVerificacao", false);
        refazer();
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao verificar biometria",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const sair = () => {
      removerDedo.value++;
    };

    const refazer = () => {
      removerDedo.value++;
      let image = document.getElementById("image");
      image.src = "";
      mensagem.value = "Selecione um dedo para começar o processo";
      biometria.value = false;
      base64Images.value = [];
      loading.value = false;
      if (props.tipoBiometria == "verificacao") {
        mensagem.value =
          "Clique em Coletar Biometria para iniciar verificação.";
      }
      if (props.tipoBiometria == "verificacaoUsuario") {
        mensagem.value =
          "Clique em Coletar Biometria para iniciar verificação de Usuario.";
      }
    };

    const receberDedo = (dedo) => {
      dedoSelecionado.value = dedo;
      mensagem.value = `Posicione o ${dedo.label} no leitor e aguarde`;
      coletarBiometria();
    };

    const receberDedosCadastrados = async () => {
      let response = undefined;
      try {
        if (
          !tenentsNovaBiometria.includes(store.state.autenticacao.cliente[0])
        ) {
          response = await store.dispatch(
            "biometria/receberDedosCadastradosNew",
            {
              id: props.userId,
            }
          );
        } else {
          response = await store.dispatch("biometria/receberDedosCadastrados", {
            id: props.userId,
          });
        }
        dedosSelecionados.value = response.data;
      } catch (error) {
        console.log(error);
      }
    };

    const validarVersao = (version) => {
      return versaoRegex.test(version);
    };

    watch(
      () => props.modal,
      () => {
        valor.value = true;
        removerDedo.value++;
        biometria.value = false;
        base64Images.value = [];
        negativePrint.value = "";
        loading.value = false;
        getVersion();
        if (
          props.tipoBiometria == "verificacao" ||
          props.tipoBiometria == "verificacaoUsuario"
        ) {
          mensagem.value =
            "Clique em Coletar Biometria para iniciar o processo e coloque o dedo no leitor para realizar a coleta.";
          return;
        }
        mensagem.value = "Selecione um dedo para começar o processo";
      }
    );

    return {
      biometria,
      valor,
      mensagem,
      removerDedo,
      refazer,
      coletarBiometria,
      sair,
      receberDedo,
      cadastrarBiometria,
      base64Images,
      coletarNovamente,
      verificarBiometria,
      loading,
      negativePrint,
      getVersion,
      mensagemErro,
      aplicacaoExecutando,
      receberDedosCadastrados,
      dedosSelecionados,
      disable,
      validarVersao,
      versaoRegex,
      loadingInicial,
      loadingCadastro,
      validarBase64,
    };
  },
};
</script>

<style scoped>
#image {
  height: 300px;
  width: 200px;
}
.alinhamento {
  text-align: center;
}
a {
  text-decoration: none;
}
</style>
